import AsyncEvent from './AsyncEvent';
import WebSocket from 'ws';
import SHA512 from "crypto-js/sha512";
import SHA1 from "crypto-js/sha1"
import Hex from "crypto-js/enc-hex"
import MessageBusService from './MessageBusService';
import log from 'loglevel';
import QueryService from "./QueryService";

const callback = {
	onConnected: new WeakMap(),
	onConnectionError: new WeakMap(),
	onClosed: new WeakMap(),
	onLoggedIn: new WeakMap(),
	onLoginError: new WeakMap(),
	onLoggedOut: new WeakMap()
};

class Session {
	constructor() {
		this.msgbus = new MessageBusService(this);
		// 싱글톤 운영해야 하나?
		Araqne.worker = new Worker('/script/worker/worker.logdb.worker.js');
		Araqne.worker.postMessage({
			'guid': 'init',
			'cmd': 'init',
			'data': !!location._testPort_ ? location._testPort_ : location.port
		});


		let defaultCallback = () => {};

		callback.onConnected.set(this, defaultCallback);
		callback.onConnectionError.set(this, (e) => {
			log.debug('connection error', e);
		});
		callback.onClosed.set(this, () => {
			log.debug('websocket closed');
		});
		callback.onLoggedIn.set(this, defaultCallback);
		callback.onLoginError.set(this, (e) => {
			log.debug('login error', e);
		});
		callback.onLoggedOut.set(this, defaultCallback);


		this.msgbus = new MessageBusService(this);

		$(window).on('unload.logout', () => {
			if(!!this.sessionId) {
				this.logoutPost(this.sessionId);
			}
		});
		$(window).on('beforeunload.closeWebConsole', this.close.bind(this));
		$(window).on('unload.closeWebConsole', this.close.bind(this));
	}

	loginByApi(key) {
		var session = this;
		return new AsyncEvent((resolve, reject) => {
			session.msgbus.send('com.logpresso.core.msgbus.ApikeyPlugin.login', { 'guid': key })
			.onSuccess(resp => {
				session.whoAmI()
				.onSuccess(loginName => {
					resolve(loginName);
				});
			})
			.onFailure((m, raw) => {
				reject(m, raw);
			});
		});
	}

	login(id, password) {
		let promiseHashType = new AsyncEvent(this._getHashType(id, password));
		promiseHashType
		.onSuccess((hash) => {
			let promiseLogin = new AsyncEvent(this._login(id, hash));
			promiseLogin
				.onSuccess(callback.onLoggedIn.get(this))
				.onFailure(callback.onLoginError.get(this));
		})
		.onFailure(callback.onLoginError.get(this));

	}

	close() {
		// console.log('close', this.ws);
		// this.ws.close();
	}

	hello(loginname) {
		return this.msgbus.send('org.araqne.dom.msgbus.LoginPlugin.hello', { 'nick': loginname, 'locale': 'ko' });
	}

	_getHashType(id, password) {
		var self = this;

		return function() {
			// 'this' is instance of AsyncEvent

			self.hello(id).onSuccess((resp) => {
				self.sessionId = resp.session_id;
				console.warn(self.sessionId);
				if(resp.otp) {
					this.done('onSuccess', password);
				}
				else {
					self.msgbus.send('org.araqne.dom.msgbus.LoginPlugin.getHashType', { 'nick': id })
					.onSuccess((resp2) => {
						if(resp2.hash == 'sha1') {
							let hashedPw = SHA1(resp.nonce2 + password).toString(Hex);
							let hash = SHA1(hashedPw + resp.nonce).toString(Hex);
							this.done('onSuccess', hash);
						}
						else if(resp2.hash == 'sha512') {
							let hashedPw = SHA512(resp.nonce2 + password).toString(Hex);
							let hash = SHA512(hashedPw + resp.nonce).toString(Hex);
							this.done('onSuccess', hash);
						}
					})
					.onFailure((m2, raw) => {
						this.done('onFailure', m2, raw);
					})
				}

			})
		}
	}

	_login(id, hash) {
		var self = this;
		return function() {
			self.msgbus.send('org.araqne.dom.msgbus.LoginPlugin.login', {
				'nick': id,
				'hash': hash,
				'force': false
			}, 0)
			.onSuccess((resp) => {
				log.debug('password matched');
				self.msgbus.send('org.araqne.msgbus.TokenPlugin.issueToken', {
					'token_data': 'logdb-auth-token'
				}, 0)
				.onSuccess((resp2) => {

					self.msgbus.send('org.araqne.logdb.msgbus.ManagementPlugin.login', {
						'token': resp2.token_id
					}, 0)
					.onSuccess((resp3) => {
						this.done('onSuccess', resp2); // login callback
					})
					.onFailure((m3, raw) => {
						this.done('onFailure', m3, raw);
					});
				})
				.onFailure((m2, raw) => {
					this.done('onFailure', m2, raw);
				});
			})
			.onFailure((m2, raw) => {
				this.done('onFailure', m2, raw);
			});
		}

	}

	onConnected(fn) {
		callback.onConnected.set(this, fn);
		return this;
	}
	onConnectionError(fn) {
		callback.onConnectionError.set(this, fn);
		return this;
	}
	onClosed(fn) {
		callback.onClosed.set(this, fn);
		return this;
	}
	onLoggedIn(fn) {
		callback.onLoggedIn.set(this, fn);
		return this;
	}
	onLoginError(fn) {
		callback.onLoginError.set(this, fn);
		return this;
	}
	onLoggedOut(fn) {
		callback.onLoggedOut.set(this, fn);
		return this;
	}

	logoutPost(sessionId) {
		var session;
		if(!!this) {
			session = this.sessionId;
		}
		if(sessionId) {
			session = sessionId;
		}
		console.warn(session);
		var param = $.param({
			'guid': session
		});
		var url = '/logpresso/logout';
		if(!navigator.sendBeacon) {
			$.ajax({
				'type': 'POST',
				'url': url,
				'async': false,
				'data': param,
				'success': function() {
					console.log('logout');
				}
			});
		}
		else {
			navigator.sendBeacon(url, param);
			console.log('logout by sendBeacon');
		}
	}

	whoAmI() {
		var session = this;
		return new AsyncEvent((resolve, reject) => {
			var client = new QueryService(session);
			client.createQuery('json "{}" | eval login = whoami()', query => {
				query.start();
				query.onTail(tail => {
					client.getResult(tail.id, 0)
					.onSuccess(resp => {
						resolve(resp.result[0].login);
					})
					.onFailure(err => {
						reject(err);
					});
				});
			});
		});
	}

}

export default Session;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/Session.js